module.exports = "pegasus_template/assets/blocks/image-2-tech.png";